/**
 * Default Configuration Values
 * These are merged with instance and region configs to ensure all properties exist
 */
import australiaInstance from './instances/australia';
import belgiumRegion from './regions/belgium';

// Default instance configuration
export const DEFAULT_INSTANCE_CONFIG = australiaInstance;

// Default region configuration
export const DEFAULT_REGION_CONFIG = belgiumRegion;

/**
 * Merge default config with provided config
 * Deep merge to ensure nested objects like validation are properly merged
 */
export const mergeWithDefaults = (defaultConfig, customConfig) => {
  return {
    ...defaultConfig,
    ...customConfig,
    // Deep merge validation if it exists
    validation: {
      ...defaultConfig.validation,
      ...(customConfig.validation || {}),
    },
  };
};

